

















































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import ChatUserList from '@/components/chat/ChatUserList.vue';
import ChatItem from '@/components/chat/ChatItem.vue';

interface UserInfo {
  id: string;
  name: string;
}

@Component({
  components: {
    'chat-user-list': ChatUserList,
    'chat-item': ChatItem
  }
})
export default class Chat extends Vue {
  @Prop({ default: true })
  isHide!: boolean;

  messages: Array<any> = [];
  i: number = 0;
  showLoader: boolean = false;
  selectedUserId: string | null = null;
  selectedUserName: string | null = null;

  selectedChat: any = {
    isSystemNotificationRequest: false,
    isAdministratorRequest: false,
    isTechSupRequest: false
  };

  isTechChat: boolean = false;
  isAdministratorChat: boolean = false;
  error: boolean = false;
  messageText: string = '';

  created() {
    this.$chatHub.unreadMessagesCount(this.currentUserId);
    this.$chatHub.$on('ReceiveMessage', this.onReceiveMessage);
    this.$chatHub.$on('ReceiveTechMessage', this.onReceiveTechMessage);    
    this.$chatHub.$on('ReceiveTechRequsetMessage', this.onReceiveTechRequsetMessage);
    this.$chatHub.$on('ReceiveAdministratorMessage', this.onReceiveAdministratorMessage);
    this.$chatHub.$on('ReceiveAdministratorRequsetMessage', this.onReceiveAdministratorRequsetMessage);
    this.$chatHub.$on('LoadMessages', this.onLoadMessages);
    this.$chatHub.$on('LoadSystemNotificationMessages', this.onLoadMessages);
    this.$chatHub.$on('UnreadMessagesCount', this.onUnreadMessagesCount);
  }

  beforeDestroy() {
    this.$chatHub.$off('ReceiveMessage', this.onReceiveMessage);
    this.$chatHub.$off('ReceiveTechMessage', this.onReceiveTechMessage);
    this.$chatHub.$off('ReceiveTechRequsetMessage', this.onReceiveTechRequsetMessage);
    this.$chatHub.$off('ReceiveAdministratorMessage', this.onReceiveAdministratorMessage);
    this.$chatHub.$off('ReceiveAdministratorRequsetMessage', this.onReceiveAdministratorRequsetMessage);
    this.$chatHub.$off('LoadMessages', this.onLoadMessages);
    this.$chatHub.$off('LoadSystemNotificationMessages', this.onLoadMessages);
    this.$chatHub.$off('UnreadMessagesCount', this.onUnreadMessagesCount);
  }

  onReceiveMessage(message: any) {
    if (this.isUserChat && message.toUserId == this.currentUserId) {
      if (message.fromUserId != this.selectedUserId) {
      } else {
        this.messages.push(message);
        this.$chatHub.markAsRead(
          this.selectedUserId,
          this.currentUserId,
          this.isTechChat,
          this.isAdministratorChat
        );
      }
    }
  }

  onReceiveTechMessage(message: any) {
    if (
      this.isTechChat &&
      this.amITechSupport &&
      (message.toUserId == this.selectedUserId ||
        message.fromUserId == this.selectedUserId)
    ) {
      this.messages.push(message);
      this.$chatHub.markAsRead(
        this.selectedUserId,
        this.currentUserId,
        this.isTechChat,
        false
      );
    }
  }

  onReceiveAdministratorMessage(message: any) {
    if (
      this.isAdministratorChat &&
      this.isAdministrator &&
      (message.toUserId == this.selectedUserId ||
        message.fromUserId == this.selectedUserId)
    ) {
      this.messages.push(message);
      this.$chatHub.markAsRead(
        this.selectedUserId,
        this.currentUserId,
        false,
        this.isAdministratorChat
      );
    }
  }

  onReceiveAdministratorRequsetMessage(message: any) {
    if (this.selectedChat.isAdministratorRequest && message.toUserId == this.currentUserId) {
      this.messages.push(message);
      this.$chatHub.markAsReadAdministratorRequestMessages(this.currentUserId);
    }
  }

  onReceiveTechRequsetMessage(message: any) {
    if (this.selectedChat.isTechSupRequest && message.toUserId == this.currentUserId) {
      this.messages.push(message);
      this.$chatHub.markAsReadTechRequestMessages(this.currentUserId);
    }
  }

  onLoadMessages(messages: any) {
    this.messages = [];

    messages.forEach((message: any) => {
      this.messages.push(message);
    });

    this.showLoader = false;
  }

  onUnreadMessagesCount(unreadMessagesCount: any) {
    this.$store.commit('chat/unreadMessagesCount', unreadMessagesCount);
  }

  updated() {
    this.$nextTick((<any>this.$refs.message).scrollIntoView());
  }

  @Watch('isHide')
  onIsHideChange() {
    if (this.isHide) {
      this.hide();
    }
  }

  hide() {
    this.selectedChat.isTechSupRequest = false;
    this.selectedUserId = null;
    this.selectedUserName = '';
    this.messages = [];
    this.$emit('hideChat');
  }

  send(event: any) {
    if (this.messageText) {
      this.sendMessage(this.messageText);
    }

    this.messageText = '';
  }

  sendMessage(text: string) {
    const message = {
      id: null,
      messageId: null,
      fromUserId: this.currentUserId,
      fromUserName: this.currentUserName,
      toUserId: this.selectedUserId,
      isToTechnicalSupport: this.selectedChat.isTechSupRequest || this.isTechChat,
      isToAdministrator: this.selectedChat.isAdministratorRequest || this.isAdministratorChat,
      dateOfSend: new Date(),
      text: text,
      self: true
    };

    this.$chatHub
      .sendMessage(message)
      .then(() => {
        this.messages.push(message);
      })
      .catch(() => {
        this.error = true;
      });
  }

  hideError() {
    this.error = false;
  }

  selectUser(info: UserInfo, isTechChat: boolean, isAdministratorChat: boolean) {
    this.selectedUserId = info.id;
    this.isTechChat = isTechChat;
    this.isAdministratorChat = isAdministratorChat;
    this.selectedUserName = info.name;

    this.selectChat('');
    this.messages = [];
    this.showLoader = true;

    this.$chatHub.loadMessages(
      this.isTechChat,
      this.isAdministratorChat,
      this.currentUserId,
      this.selectedUserId
    );
  }

  selectChat(type: string) {
    Object.keys(this.selectedChat).forEach(sc => {
      //@ts-ignore
      this.selectedChat[sc] = sc == type ? true : false;
    });
  }

  selectRequest(type: string) {
    this.selectedUserId = null;
    this.showLoader = true;
    this.selectChat(type);
    this.isTechChat = false;

    switch (type) {
      case 'isSystemNotificationRequest':
        this.selectedUserName = this.$t('Уведомления системы') as string;

        this.$chatHub
          .loadSystemNotificationMessages(this.currentUserId)
          .finally(() => {
            this.showLoader = false;
          })
          .then(() => {
            this.showLoader = false;
          });          
        break;
      case 'isAdministratorRequest':
        this.selectedUserName = this.$t('Администраторы') as string;

        this.$chatHub
          .loadAdministratorRequestMessages(this.currentUserId)
          .then(() => {
            this.showLoader = false;
          });
        break;
      case 'isTechSupRequest':
        this.selectedUserName = this.$t('Техническая поддержка') as string;

        this.$chatHub
          .loadTechSupRequestMessages(this.currentUserId)
          .then(() => {
            this.showLoader = false;
          });
        break;
    }
  }

  get currentUserId() {
    return this.$auth.user().id;
  }

  get currentUserName() {
    return `${this.$auth.user().login} (${this.$auth.user().name})`
  }

  get amITechSupport() {
    return this.$auth.user().isTechnicalSupport;
  }

  get isAdministrator() {
    return this.$auth.user().isAdministrator;
  }

  get isUserChat() {
    return Object.values(this.selectedChat).every(s => !s);
  }

  get isChatItemSelected() {
    return Object.values(this.selectedChat).some(s => !!s);
  }
}
